/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '../../vimeo';

const body = `<h4>Add vertex</h4>

<p>Add a vertex on an edge.</p>

<div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="${vimeo('556486558')}" loading="lazy"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
</div>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>V</b>: Add vertex</li>
    <li class='shortcuts__item'><b>Shift-V</b>: Add at middle of edge</li>
</ul>`;

export default function AddVertexTooltip() {
    return h('div', { innerHTML: body });
}
